import { Button } from "react-bootstrap";

export const CGenerateLabelButton = ({ data, onGenerate, loading,text }) => (
    <Button
        variant="contained"
        className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
        color="primary"
        size="small"
        disabled={loading}
        onClick={() => onGenerate(data)}
    >
        {loading ? "Generating..." : text}
    </Button>
);